import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { EventRating } from './types'
import { useCurrentUser } from './useCurrentUser'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useUserEventRating = (eventId?: string) => {
  const fetchWithAuth = useFetchWithAuth()
  const { data: userData } = useCurrentUser()
  const userId = userData?.userId || ''

  const getUserEventRating: QueryFunction<EventRating | null> = async () => {
    if (!eventId) {
      throw new Error('Event ID is required to fetch user rating')
    }

    const response = await fetchWithAuth(
      `${URL}/events/${eventId}/ratings/me`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }
    )

    return response
  }

  return useQuery({
    queryKey: ['userEventRating', eventId, userId] as const,
    queryFn: getUserEventRating,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: !!eventId && !!userId && eventId.length > 0,
  })
}
